// extracted by mini-css-extract-plugin
module.exports = {"pageHolder":"Modal_pageHolder__bTEJY","modal":"Modal_modal__1P7df"};